import { useEffect } from 'react';

import { useNotificationStore } from '@/stores/notificationstore';
import { useTranslation } from 'react-i18next';

export default function VersionUpdate() {
  const { t } = useTranslation();
  const showNotification = useNotificationStore((state) => state.showNotification);

  useEffect(() => {
    const lastKnownVersion = localStorage.getItem('lastKnownVersion');
    // If there is no lastKnownVersion, set it to the current version (VERSION)
    // and no message is shown
    if (lastKnownVersion === null) {
      localStorage.setItem('lastKnownVersion', VERSION);
      return;
    }

    // Only notify if the version is different from the stored version
    if (lastKnownVersion !== VERSION) {
      showNotification('success', t('error.dialog.newVersionUpdate'), undefined, 5);
      localStorage.setItem('lastKnownVersion', VERSION);
    }
  }, [showNotification, t]);

  return null;
}
